import { canDeleteEmployees, onEmployee, onEmployeeList } from './employee'
import { onBuilding } from './building'
import { onFloor } from './floor'
import { onAsset } from './asset'
import { onNeighborhood } from './neighborhood'
export { default as Permissions } from './Permissions'
export * from './types'

export default {
  canDeleteEmployees,
  onEmployee,
  onEmployeeList,
  onBuilding,
  onFloor,
  onAsset,
  onNeighborhood,
}
